import React from 'react';

const SlickButton = ({ currentSlide, slideCount, children, ...props }) => <span {...props}>{children}</span>;
export const productsSwiperSettings = {
	dots: false,
	infinite: false,
	prevArrow: (
		<SlickButton>
			<i className="fa fa-angle-left" aria-hidden="true" />
		</SlickButton>
	),
	nextArrow: (
		<SlickButton>
			<i className="fa fa-angle-right" aria-hidden="true" />
		</SlickButton>
	),
	responsive: [
		{
			breakpoint: 3000,
			settings: {
				slidesToShow: 6,
				slidesToScroll: 6
			}
		},
		{
			breakpoint: 1600,
			settings: {
				slidesToShow: 5,
				slidesToScroll: 5
			}
		},
		{
			breakpoint: 1200,
			settings: {
				slidesToShow: 4.2,
				slidesToScroll: 4.2
			}
		},
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 3.5,
				slidesToScroll: 3
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 3.2,
				slidesToScroll: 3
			}
		},
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 2.5,
				slidesToScroll: 2
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 2.2,
				slidesToScroll: 2
			}
		}
	]
};
